<div class="overbooking-grid-mat-input-root">
  <table
    *ngFor="let gridSlotConf of value; let i = index"
    class="overbooking-grid-mat-input-table"
    [class.overbooking-grid-mat-input-table--disabled]="disabled"
  >
    <tr class="overbooking-grid-mat-input-row">
      <th></th>
      <th *ngFor="let time of gridTimeConfig[i]" class="overbooking-grid-mat-input-hours">{{ time }}</th>
    </tr>
    <tr *ngFor="let slots of gridSlotConf" class="overbooking-grid-mat-input-row">
      <th class="overbooking-grid-mat-input-date">{{ slots.date | localizedDate : 'EEEEEE, d.M' }}</th>
      <td
        *ngFor="let slot of slots.time"
        (click)="selectSlot(slot)"
        [ngClass]="{
          'overbooking-grid-mat-input-slot--selected': selectedSlot === slot.startDatetime,
          'overbooking-grid-mat-input-slot--booked': slot.isBooked,
          'overbooking-grid-mat-input-slot--not-available': !slot.isBooked && !slot.isAvailable
        }"
        class="overbooking-grid-mat-input-slot"
      ></td>
    </tr>
  </table>
</div>
